export const YMME_NAME = 'vehicleConfiguratorModalYmme'
export const LICENSE_PLATE_NAME = 'vehicleConfiguratorModalLicensePlate'
